
document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector("[call-us-information]")) {
        const contactUsBlock = new ContactUsBlock();
        contactUsBlock.init();
    }
});

class ContactUsBlock {
    constructor() {
        this.arrayRegexes = [
            /(\+\d{2}\s+\(\d{1}\)\s+\d{10})/g, //+39 (0) 3491491255 
            /(\+\d{2}\s+\(\d{1}\)\s+\d{4}\s+\d{6})/g, //+44 (0) 7889 126106
            /(\+\d{2}\s+\(\d{1}\)\s+\d{1}\s+\d{2}\s+\d{2}\s+\d{2}\s+\d{2})/g, //+33 (0) 4 78 33 10 67
            /(\+\d{1}\s+\(\d{1}\)\s+\d{3}\s+\d{3}\s+\d{4})/g, //+7 (8) 985 897 2999
            /(\+\d{3}\s+\(\d{1}\)\s+\d{3}\s+\d{3}\s+\d{3})/g, //+420 (0) 556 723 044
            /(\+\d{2}\s+\d{3}\s+\d{3}\s+\d{2}\s+\d{2})/g, //+90 542 315 87 63
            /(\d{4}\s+\(\d{1}\)\s+\d{3}\s+\d{6})/g, //0031 (0) 165 596907
            /(\+\d{1}\s+\d{3}\s+\d{7})/g, //+7 495 4103930
            /(\d{1}-\d{3}-\d{3}-\d{4})/g, //1-603-643-3441
            /(\d{3}-\d{3}-\d{4})/g, //603-643-3441
            /(\(\d{3}\)\s+\d{3}-\d{4})/g, //(603) 643-3441
            /(\d{1}\s+\d{3}\s+\d{3}\s+\d{4})/g, //1 603 643 3441
            /(\+\d{2}\s+\(\d{1}\)\s+\d{3}\s+\d{6})/g, //+44 (0) 788 126106
            /(\+\d{2}\s+\(\d{1}\)\s+\d{4}\s+\d{3}\s+\d{3})/g, //+44 (0) 7974 726 225
            /(\+\d{2}\s+\(\d{1}\)\s+\d{3}\s+\d{3}\s+\d{4})/g, //+49 (0) 175 228 9890
            /(\+\d{2}\s+\(\d{2}\)\s+\d{4}\s+\d{4})/g //+52 (55) 5681 8109 
        ];
    }

    init() {
        this.processPhoneNumbers();
    }

    processPhoneNumbers() {
        const elements = document.querySelectorAll("[call-us-information] p:not([processed])");

        elements.forEach(item => {
            let phoneNumber = item.innerHTML;

            for (let regex of this.arrayRegexes) {
                if (phoneNumber.match(regex)) {
                    phoneNumber = this.contactUsFormatPhoneNumber(phoneNumber, regex);
                    break;
                }
            }
            item.innerHTML = phoneNumber;
            item.setAttribute("processed", "1");
        });
    }

    contactUsFormatPhoneNumber(input, expression) {
        return input.replace(expression, "<a href='tel:$1'>$1</a>");
    }
}